import { useState } from "react";

import ImgIconInfos from "../../../img/icons/specs/infos.png";

const ProductSet = ({ products, display_disabled = false, display_desc = false, benefit = false, loading = false }) => {
  const [displayDesc, setDisplayDesc] = useState(false);

  if (!products) return;

  return (
    <ul className="productset">
      {
        products.assigned_products.map((p, index) => {
          return (((p.qty > 0) || display_disabled) &&
            <li key={p.product.name} className={(parseFloat(p.qty) === 0) ? 'disabled' : null}>
              <div className="product_photo" style={{ backgroundImage: `url(${process.env.REACT_APP_SIM_IMG_URL}/product_photos/${p.product.photo_file})` }}>
                { (p.qty > 1) && <div className="qty">x{ p.qty }</div> }
              </div>
              <div className="desc">
                <div className="product_name">{ p.product.name }
                  { display_desc && p.product.description &&
                  <span>
                    <img alt='' className="infos" src={ImgIconInfos} onClick={() => setDisplayDesc(displayDesc === index ? null : index)}/>
                    <div className="description" style={{display: displayDesc === index ? 'block' : 'none'}} dangerouslySetInnerHTML={{__html: p.product.description.replace(/\n/g, '<br />')}} onClick={() => setDisplayDesc(null)}/>
                  </span> }
                </div>
                { p.product.brand && <div className="product_brand" dangerouslySetInnerHTML={{__html: p.product.brand.name}}/> }
              </div>
            </li>
          );
        })
      }
      { benefit && 
      <div className='gradient benefit'>
        <span className={'loader ' + (loading ? 'loading' : '')}>{ benefit.main.split(' : ')[0] } : <br/>{ benefit.main.split(' : ')[1] }</span>
      </div>
      }
    </ul>
  );
};

export default ProductSet;